import { useSelector } from "react-redux";

import { Box, makeStyles, Typography } from "@material-ui/core";
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";

import { LABELS } from "../constants";
import IconCard from "../../../tasks/iconCard";
import onePersonIcon from "../../../../../assets/images/icons/workspace/one-person.svg";
import onePersonIconSelected from "../../../../../assets/images/icons/workspace/one-person-selected.svg";
import percentIcon from "../../../../../assets/images/icons/workspace/percent.svg";
import percentIconSelected from "../../../../../assets/images/icons/workspace/percent-selected.svg";
import includedIcon from "../../../../../assets/images/icons/workspace/included.svg";
import includedIconSelected from "../../../../../assets/images/buildings/Pound.svg";
import ByArea from "../../../../../components/parts/byArea";

const areaConsumptionIcon = [
  {
    id: "FIX_PRICE",
    icon: onePersonIcon,
    iconSelected: onePersonIconSelected,
  },
  {
    id: "BY_AREA",
    component: ByArea,
  },
  {
    id: "PERCENT",
    icon: percentIcon,
    iconSelected: percentIconSelected,
  },
  {
    id: "NOTHING",
    icon: includedIcon,
    iconSelected: includedIconSelected,
  },
];

const useStyles = makeStyles(() => ({
  heading: {
    fontSize: 30,
    fontWeight: 700,
  },
  iconDiv: {
    display: "flex",
  },
  textStyle: {
    fontSize: 14,
    marginTop: 14,
    marginBottom: 14,
  },
  topDiv: {
    marginTop: 50,
  },
  textDesign: {
    fontSize: 18,
    marginLeft: 3,
    marginTop: 45,
  },
  textDesignIcon: {
    marginTop: 53,
    fontSize: 12,
  },
  bottomDiv: {
    display: "flex",
    paddingBottom: 100,
  },
  centerStyle: {
    display: "flex",
    justifyContent: "center",
    marginTop: 36,
  },
}));

export const PublicAreaConsumption = ({ data, onDataChange }) => {
  const classes = useStyles();
  const { user } = useSelector((state) => state.auth);

  return (
    <Box>
      <Typography className={classes.heading}>
        Do you charge the tenants for public areas consumption?
      </Typography>
      <Box className={classes.topDiv}>
        <Box className={classes.iconDiv}>
          {areaConsumptionIcon.map((icon, i) => {
            return (
              <IconCard
                key={i}
                id={icon.id}
                centerStyle={classes.centerStyle}
                selected={data === icon.id}
                src={data === icon.id ? icon.iconSelected : icon.icon}
                onClick={(id) => onDataChange(null, "tenant_public_area", id)}
                Component={icon.component}
              />
            );
          })}
        </Box>
        <Typography className={classes.textStyle}>
          {LABELS[data]?.replace("sqft", user?.unit_system)}
        </Typography>
      </Box>
      <Box className={classes.bottomDiv}>
        <FiberManualRecordIcon className={classes.textDesignIcon} />
        <Typography className={classes.textDesign}>
          You&apos;ll be asked to insert later on the exact price per each tenant
        </Typography>
      </Box>
    </Box>
  );
};
